import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_ROLES: createActionType(FULL_NAMESPACE, "GET_ROLES"),
    GET_ROLES_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ROLES_COMPLETED"),
    REMOVE_ROLES: createActionType(FULL_NAMESPACE, "REMOVE_ROLES"),
    REMOVE_ROLES_COMPLETED: createActionType(FULL_NAMESPACE, "REMOVE_ROLES_COMPLETED"),
    SAVE_ROLE: createActionType(FULL_NAMESPACE, "SAVE_ROLE"),
    SAVE_ROLE_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_ROLE_COMPLETED"),
    SAVE_ROLE_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_ROLE_REJECTED"),
    GET_ROLE_DETAILS: createActionType(FULL_NAMESPACE, "GET_ROLE_DETAILS"),
    GET_ROLE_DETAILS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ROLE_DETAILS_COMPLETED"),
    GET_ROLE_DETAILS_REJECTED: createActionType(FULL_NAMESPACE, "GET_ROLE_DETAILS_REJECTED"),
    SET_EXPANDED_PERMISSIONS: createActionType(FULL_NAMESPACE, "SET_EXPANDED_PERMISSIONS")
};
